// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TodayModal_overlay__8jY1z {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 1;
}

.TodayModal_overlay__8jY1z.TodayModal_closing__3p5Ey {
  animation: TodayModal_fadeOut__sJ-VN 0.3s ease-in forwards;
}

.TodayModal_modal__ns89o {
  background: #181a1b;
  color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  transform: scale(0.8) translateY(30px);
  opacity: 0;
}

.TodayModal_modal__ns89o.TodayModal_loaded__00fWC {
  animation: TodayModal_modalIn__8WSry 0.4s ease-out forwards;
}

.TodayModal_modal__ns89o.TodayModal_closing__3p5Ey {
  animation: TodayModal_modalOut__t9gfK 0.3s ease-in forwards;
}

.TodayModal_header__GPPDB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #444;
}

.TodayModal_header__GPPDB h2 {
  margin: 0;
  font-size: 24px;
}

.TodayModal_closeButton__atnZO {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.TodayModal_closeButton__atnZO:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.TodayModal_aiRapportButton__iVVLe {
  background: rgba(0, 123, 255, 0.8);
  border: none;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.TodayModal_aiRapportButton__iVVLe:hover {
  background: rgba(0, 123, 255, 1);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
}

.TodayModal_aiRapportButton__iVVLe i {
  font-size: 14px;
}

.TodayModal_dateSelector__IZfLd {
  padding: 20px;
  border-bottom: 1px solid #444;
  display: flex;
  align-items: center;
  gap: 10px;
}

.TodayModal_dateInput__2spcQ {
  padding: 8px;
  border: 1px solid #444;
  border-radius: 4px;
  background: #23272a;
  color: white;
  font-size: 14px;
}

.TodayModal_content__4NXVB {
  padding: 20px;
}

/* Content-Animation bei Datum-Wechsel (dataVersion-Key aendert sich -> Remount) */
.TodayModal_contentAnimate__kan68 {
  animation: TodayModal_contentIn__Vqgfx 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes TodayModal_contentIn__Vqgfx {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

.TodayModal_loading__gOUDr {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  color: #bbb;
}

.TodayModal_spinner__HdsOG {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top: 4px solid #007BFF;
  border-radius: 50%;
  animation: TodayModal_spin__Aoawf 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes TodayModal_spin__Aoawf {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.TodayModal_spinAnimationOuter__9rJNo {
  animation: TodayModal_spin__Aoawf 2s linear forwards;
}

.TodayModal_spinAnimationInner__\\+ttkk {
  animation: TodayModal_spin__Aoawf 1.5s linear reverse forwards;
}


.TodayModal_summary__TmCKi {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(0, 123, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(0, 123, 255, 0.3);
}

.TodayModal_summary__TmCKi h3 {
  margin: 0;
  color: #007BFF;
  font-size: 18px;
}

.TodayModal_noData__8EBGZ {
  text-align: center;
  padding: 40px;
  color: #bbb;
}

.TodayModal_bucketGroups__mNZRK {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.TodayModal_bucketGroup__iuboM {
  border: 1px solid #555;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.1);
}

.TodayModal_bucketHeader__\\+cTp9 {
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-bottom: 1px solid #555;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.TodayModal_bucketHeader__\\+cTp9 h3 {
  margin: 0;
  font-size: 18px;
  color: #fff;
}

.TodayModal_bucketTotalTime__U8JrM {
  font-weight: bold;
  color: #007BFF;
  font-size: 14px;
  font-family: monospace;
  background: rgba(0, 123, 255, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgba(0, 123, 255, 0.3);
}

.TodayModal_ticketGroups__RNiSx {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.TodayModal_ticketGroup__qX1VT {
  border: 1px solid #444;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.02);
}

.TodayModal_ticketHeader__\\+G-yt {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 12px;
  border-bottom: 1px solid #444;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
}

.TodayModal_clickable__GIV8Y {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.TodayModal_clickable__GIV8Y:hover {
  background: rgba(255, 255, 255, 0.08);
}

.TodayModal_ticketInfo__U6K8d {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.TodayModal_dropdownIcon__WOz6e {
  margin-right: 8px;
  font-size: 12px;
  color: #007BFF;
  min-width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TodayModal_ticketHeader__\\+G-yt h4 {
  margin: 0;
  font-size: 14px;
  color: #fff;
}

.TodayModal_ticketMeta__v0E4K {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-left: 12px;
}

.TodayModal_project__7IaIK {
  background: rgba(0, 123, 255, 0.2);
  color: #4a9eff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  /* Fix 06.10.2026: Chip bleibt einzeilig und kuerzt mit Ellipse - ein 2-zeiliger
     Chip hat dem Titel bei schmalen Screens die ganze Breite geraubt (vertikaler Text) */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 220px;
}

.TodayModal_priority__V4wlx {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: auto;
}

.TodayModal_totalTime__lUofE {
  font-weight: bold;
  color: #28a745;
  font-size: 12px;
  min-width: 180px;
  text-align: right;
}

.TodayModal_timeEntries__QGnl5 {
  padding: 0;
}

.TodayModal_timeEntry__zTpHY {
  padding: 0 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  position: relative;
}

.TodayModal_hoverable__UX2TS:hover .TodayModal_editButton__iTYc7 {
  opacity: 1;
  visibility: visible;
}

.TodayModal_timeEntry__zTpHY:last-child {
  border-bottom: none;
}

.TodayModal_entryTime__vYY9t {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: monospace;
  font-size: 12px;
  min-width: 100px;
}

.TodayModal_startTime__S-aJH {
  color: #28a745;
}

.TodayModal_endTime__5Er4E {
  color: #6c757d;
}

.TodayModal_running__eHcNX {
  color: #ffc107;
  font-style: italic;
}

.TodayModal_entryDuration__RPFFQ {
  font-weight: bold;
  color: #007BFF;
  font-family: monospace;
  min-width: 80px;
  font-size: 12px;
  margin-left: auto;
}

.TodayModal_ticketTitle__DY6zl {
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.TodayModal_stepInfo__Y9SLi {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  padding: 1px 4px;
  border-radius: 4px;
  font-size: 10px;
}

/* Edit Button */
.TodayModal_editButton__iTYc7 {
  background: rgba(0, 123, 255, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  font-size: 12px;
  margin-left: 8px;
}

.TodayModal_editButton__iTYc7:hover {
  background: rgba(0, 123, 255, 1);
  transform: scale(1.05);
}


.TodayModal_timeInput__X5KAa {
  background: #23272a;
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  font-family: monospace;
  width: 80px;
}

.TodayModal_timeInput__X5KAa:focus {
  outline: none;
  border-color: #007BFF;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.TodayModal_editButtons__sRQMT {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.TodayModal_saveButton__TnS9p {
  background: rgba(40, 167, 69, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.TodayModal_saveButton__TnS9p:hover {
  background: rgba(40, 167, 69, 1);
  transform: scale(1.05);
}

.TodayModal_cancelButton__-CPhc {
  background: rgba(255, 99, 132, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.TodayModal_cancelButton__-CPhc:hover {
  background: rgba(255, 99, 132, 1);
  transform: scale(1.05);
}

.TodayModal_description__XW7Nj {
  color: #bbb;
  font-size: 10px;
  font-style: italic;
}

.TodayModal_completedSteps__vl3bd {
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.3);
  border-radius: 4px;
  padding: 4px 6px;
  margin-top: 4px;
  color: #28a745;
  font-size: 10px;
}

.TodayModal_completedSteps__vl3bd strong {
  color: #28a745;
}

.TodayModal_completedSteps__vl3bd ul {
  color: #28a745;
}

/* Animations */


@keyframes TodayModal_fadeIn__--9sm {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes TodayModal_fadeOut__sJ-VN {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes TodayModal_modalIn__8WSry {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(30px);
  }
  60% {
    opacity: 0.8;
    transform: scale(1.02) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes TodayModal_modalOut__t9gfK {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(30px);
  }
}

/* Logo fade in/out animation for loading */
@keyframes TodayModal_fadeInOut__uKoSQ {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

@keyframes TodayModal_loadingFadeOut__tZQu6 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.TodayModal_loadingContainerFadeOut__HqCdw {
  animation: TodayModal_loadingFadeOut__tZQu6 0.3s ease-out forwards;
}

.TodayModal_loadingAnimationContainer__pai54 {
  animation: TodayModal_fadeInOut__uKoSQ 2s ease-in-out infinite; /* Adjust duration and timing as needed */
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .TodayModal_modal__ns89o {
    width: 95%;
    height: 90vh;
    margin: 0;
  }
  
  /* Fix 06.10.2026: Titel bekommt seine eigene volle Zeile, Meta (Projekt + Prioritaet)
     rueckt darunter - vorher drueckte die Meta den Titel auf ~0 Breite (vertikaler Text) */
  .TodayModal_ticketInfo__U6K8d {
    flex-wrap: wrap;
  }

  .TodayModal_ticketTitle__DY6zl {
    flex: 1 1 100%;
  }

  .TodayModal_ticketMeta__v0E4K {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 20px;
    gap: 8px;
  }

  .TodayModal_project__7IaIK {
    max-width: 100%;
    flex: 0 1 auto;
  }
  
  .TodayModal_timeEntry__zTpHY {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .TodayModal_entryDuration__RPFFQ {
    min-width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TodayModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,0DAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,2DAAyC;AAC3C;;AAEA;EACE,2DAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,kFAAkF;AAClF;EACE,2EAAyD;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,oDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,oDAAkC;AACpC;;AAEA;EACE,8DAA4C;AAC9C;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;yFACuF;EACvF,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;;;AAGf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kEAAgD;AAClD;;AAEA;EACE,8DAA4C,EAAE,yCAAyC;AACzF;;AAEA,yBAAyB;AACzB;EACE;IACE,UAAU;IACV,YAAY;IACZ,SAAS;EACX;;EAEA;2FACyF;EACzF;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  opacity: 1;\n}\n\n.overlay.closing {\n  animation: fadeOut 0.3s ease-in forwards;\n}\n\n.modal {\n  background: #181a1b;\n  color: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);\n  transform: scale(0.8) translateY(30px);\n  opacity: 0;\n}\n\n.modal.loaded {\n  animation: modalIn 0.4s ease-out forwards;\n}\n\n.modal.closing {\n  animation: modalOut 0.3s ease-in forwards;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #444;\n}\n\n.header h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 20px;\n  padding: 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.aiRapportButton {\n  background: rgba(0, 123, 255, 0.8);\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.aiRapportButton:hover {\n  background: rgba(0, 123, 255, 1);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);\n}\n\n.aiRapportButton i {\n  font-size: 14px;\n}\n\n.dateSelector {\n  padding: 20px;\n  border-bottom: 1px solid #444;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dateInput {\n  padding: 8px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  background: #23272a;\n  color: white;\n  font-size: 14px;\n}\n\n.content {\n  padding: 20px;\n}\n\n/* Content-Animation bei Datum-Wechsel (dataVersion-Key aendert sich -> Remount) */\n.contentAnimate {\n  animation: contentIn 0.35s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes contentIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px;\n  color: #bbb;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.2);\n  border-top: 4px solid #007BFF;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.spinAnimationOuter {\n  animation: spin 2s linear forwards;\n}\n\n.spinAnimationInner {\n  animation: spin 1.5s linear reverse forwards;\n}\n\n\n.summary {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: rgba(0, 123, 255, 0.1);\n  border-radius: 6px;\n  border: 1px solid rgba(0, 123, 255, 0.3);\n}\n\n.summary h3 {\n  margin: 0;\n  color: #007BFF;\n  font-size: 18px;\n}\n\n.noData {\n  text-align: center;\n  padding: 40px;\n  color: #bbb;\n}\n\n.bucketGroups {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.bucketGroup {\n  border: 1px solid #555;\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.bucketHeader {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 12px;\n  border-bottom: 1px solid #555;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bucketHeader h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #fff;\n}\n\n.bucketTotalTime {\n  font-weight: bold;\n  color: #007BFF;\n  font-size: 14px;\n  font-family: monospace;\n  background: rgba(0, 123, 255, 0.1);\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 123, 255, 0.3);\n}\n\n.ticketGroups {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n}\n\n.ticketGroup {\n  border: 1px solid #444;\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.ticketHeader {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 8px 12px;\n  border-bottom: 1px solid #444;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 30px;\n}\n\n.clickable {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.clickable:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.ticketInfo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.dropdownIcon {\n  margin-right: 8px;\n  font-size: 12px;\n  color: #007BFF;\n  min-width: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ticketHeader h4 {\n  margin: 0;\n  font-size: 14px;\n  color: #fff;\n}\n\n.ticketMeta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-left: 12px;\n}\n\n.project {\n  background: rgba(0, 123, 255, 0.2);\n  color: #4a9eff;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  /* Fix 06.10.2026: Chip bleibt einzeilig und kuerzt mit Ellipse - ein 2-zeiliger\n     Chip hat dem Titel bei schmalen Screens die ganze Breite geraubt (vertikaler Text) */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  max-width: 220px;\n}\n\n.priority {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-left: auto;\n}\n\n.totalTime {\n  font-weight: bold;\n  color: #28a745;\n  font-size: 12px;\n  min-width: 180px;\n  text-align: right;\n}\n\n.timeEntries {\n  padding: 0;\n}\n\n.timeEntry {\n  padding: 0 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  min-height: 30px;\n  position: relative;\n}\n\n.hoverable:hover .editButton {\n  opacity: 1;\n  visibility: visible;\n}\n\n.timeEntry:last-child {\n  border-bottom: none;\n}\n\n.entryTime {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: monospace;\n  font-size: 12px;\n  min-width: 100px;\n}\n\n.startTime {\n  color: #28a745;\n}\n\n.endTime {\n  color: #6c757d;\n}\n\n.running {\n  color: #ffc107;\n  font-style: italic;\n}\n\n.entryDuration {\n  font-weight: bold;\n  color: #007BFF;\n  font-family: monospace;\n  min-width: 80px;\n  font-size: 12px;\n  margin-left: auto;\n}\n\n.ticketTitle {\n  flex: 1;\n  min-width: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n.stepInfo {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  padding: 1px 4px;\n  border-radius: 4px;\n  font-size: 10px;\n}\n\n/* Edit Button */\n.editButton {\n  background: rgba(0, 123, 255, 0.8);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n.editButton:hover {\n  background: rgba(0, 123, 255, 1);\n  transform: scale(1.05);\n}\n\n\n.timeInput {\n  background: #23272a;\n  border: 1px solid #444;\n  border-radius: 4px;\n  color: white;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-family: monospace;\n  width: 80px;\n}\n\n.timeInput:focus {\n  outline: none;\n  border-color: #007BFF;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n.editButtons {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.saveButton {\n  background: rgba(40, 167, 69, 0.8);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.saveButton:hover {\n  background: rgba(40, 167, 69, 1);\n  transform: scale(1.05);\n}\n\n.cancelButton {\n  background: rgba(255, 99, 132, 0.8);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background: rgba(255, 99, 132, 1);\n  transform: scale(1.05);\n}\n\n.description {\n  color: #bbb;\n  font-size: 10px;\n  font-style: italic;\n}\n\n.completedSteps {\n  background: rgba(40, 167, 69, 0.1);\n  border: 1px solid rgba(40, 167, 69, 0.3);\n  border-radius: 4px;\n  padding: 4px 6px;\n  margin-top: 4px;\n  color: #28a745;\n  font-size: 10px;\n}\n\n.completedSteps strong {\n  color: #28a745;\n}\n\n.completedSteps ul {\n  color: #28a745;\n}\n\n/* Animations */\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes modalIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.8) translateY(30px);\n  }\n  60% {\n    opacity: 0.8;\n    transform: scale(1.02) translateY(-5px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes modalOut {\n  0% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.8) translateY(30px);\n  }\n}\n\n/* Logo fade in/out animation for loading */\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n}\n\n@keyframes loadingFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.loadingContainerFadeOut {\n  animation: loadingFadeOut 0.3s ease-out forwards;\n}\n\n.loadingAnimationContainer {\n  animation: fadeInOut 2s ease-in-out infinite; /* Adjust duration and timing as needed */\n}\n\n/* Mobile optimizations */\n@media (max-width: 768px) {\n  .modal {\n    width: 95%;\n    height: 90vh;\n    margin: 0;\n  }\n  \n  /* Fix 06.10.2026: Titel bekommt seine eigene volle Zeile, Meta (Projekt + Prioritaet)\n     rueckt darunter - vorher drueckte die Meta den Titel auf ~0 Breite (vertikaler Text) */\n  .ticketInfo {\n    flex-wrap: wrap;\n  }\n\n  .ticketTitle {\n    flex: 1 1 100%;\n  }\n\n  .ticketMeta {\n    flex: 1 1 auto;\n    min-width: 0;\n    margin-left: 20px;\n    gap: 8px;\n  }\n\n  .project {\n    max-width: 100%;\n    flex: 0 1 auto;\n  }\n  \n  .timeEntry {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .entryDuration {\n    min-width: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `TodayModal_overlay__8jY1z`,
	"closing": `TodayModal_closing__3p5Ey`,
	"fadeOut": `TodayModal_fadeOut__sJ-VN`,
	"modal": `TodayModal_modal__ns89o`,
	"loaded": `TodayModal_loaded__00fWC`,
	"modalIn": `TodayModal_modalIn__8WSry`,
	"modalOut": `TodayModal_modalOut__t9gfK`,
	"header": `TodayModal_header__GPPDB`,
	"closeButton": `TodayModal_closeButton__atnZO`,
	"aiRapportButton": `TodayModal_aiRapportButton__iVVLe`,
	"dateSelector": `TodayModal_dateSelector__IZfLd`,
	"dateInput": `TodayModal_dateInput__2spcQ`,
	"content": `TodayModal_content__4NXVB`,
	"contentAnimate": `TodayModal_contentAnimate__kan68`,
	"contentIn": `TodayModal_contentIn__Vqgfx`,
	"loading": `TodayModal_loading__gOUDr`,
	"spinner": `TodayModal_spinner__HdsOG`,
	"spin": `TodayModal_spin__Aoawf`,
	"spinAnimationOuter": `TodayModal_spinAnimationOuter__9rJNo`,
	"spinAnimationInner": `TodayModal_spinAnimationInner__+ttkk`,
	"summary": `TodayModal_summary__TmCKi`,
	"noData": `TodayModal_noData__8EBGZ`,
	"bucketGroups": `TodayModal_bucketGroups__mNZRK`,
	"bucketGroup": `TodayModal_bucketGroup__iuboM`,
	"bucketHeader": `TodayModal_bucketHeader__+cTp9`,
	"bucketTotalTime": `TodayModal_bucketTotalTime__U8JrM`,
	"ticketGroups": `TodayModal_ticketGroups__RNiSx`,
	"ticketGroup": `TodayModal_ticketGroup__qX1VT`,
	"ticketHeader": `TodayModal_ticketHeader__+G-yt`,
	"clickable": `TodayModal_clickable__GIV8Y`,
	"ticketInfo": `TodayModal_ticketInfo__U6K8d`,
	"dropdownIcon": `TodayModal_dropdownIcon__WOz6e`,
	"ticketMeta": `TodayModal_ticketMeta__v0E4K`,
	"project": `TodayModal_project__7IaIK`,
	"priority": `TodayModal_priority__V4wlx`,
	"totalTime": `TodayModal_totalTime__lUofE`,
	"timeEntries": `TodayModal_timeEntries__QGnl5`,
	"timeEntry": `TodayModal_timeEntry__zTpHY`,
	"hoverable": `TodayModal_hoverable__UX2TS`,
	"editButton": `TodayModal_editButton__iTYc7`,
	"entryTime": `TodayModal_entryTime__vYY9t`,
	"startTime": `TodayModal_startTime__S-aJH`,
	"endTime": `TodayModal_endTime__5Er4E`,
	"running": `TodayModal_running__eHcNX`,
	"entryDuration": `TodayModal_entryDuration__RPFFQ`,
	"ticketTitle": `TodayModal_ticketTitle__DY6zl`,
	"stepInfo": `TodayModal_stepInfo__Y9SLi`,
	"timeInput": `TodayModal_timeInput__X5KAa`,
	"editButtons": `TodayModal_editButtons__sRQMT`,
	"saveButton": `TodayModal_saveButton__TnS9p`,
	"cancelButton": `TodayModal_cancelButton__-CPhc`,
	"description": `TodayModal_description__XW7Nj`,
	"completedSteps": `TodayModal_completedSteps__vl3bd`,
	"loadingContainerFadeOut": `TodayModal_loadingContainerFadeOut__HqCdw`,
	"loadingFadeOut": `TodayModal_loadingFadeOut__tZQu6`,
	"loadingAnimationContainer": `TodayModal_loadingAnimationContainer__pai54`,
	"fadeInOut": `TodayModal_fadeInOut__uKoSQ`,
	"fadeIn": `TodayModal_fadeIn__--9sm`
};
export default ___CSS_LOADER_EXPORT___;
